// MACHINERY V2 (Stroje) — THE fetch shape for the active fleet (MDEL-FE review
// finding 5).
//
// >>> THE ONLY THING A v2 SURFACE MAY HAND TO `getMachines`. <<<
//
// `MachinesQuery` carries four fields, but only two of them are SERVER-side in
// v2. `typeId` and `manufacturerId` are CLIENT-side facets — and FleetPage
// .tsx:166/171 write them into the SAME shared slice query that the mutation
// handlers read back. Sending a facet to the endpoint narrows the response,
// while `state.machines` is the COMPLETE set that every facet count and the
// location tree derive from (useFleetPageData's `flat`). So a refresh that
// passes the raw query replaces the cache with one facet's worth of machines.
//
// AND IT DOES NOT SELF-REPAIR. useFleetPageData's fetch effect depends on this
// shape, so clearing the facet afterwards changes nothing it watches and never
// re-fetches: the missing active machines stay missing until a remount or a
// search / group-by change. The user's reading of that is "I deleted one
// machine and half my fleet disappeared".
//
// Its own module rather than an export from useFleetPageData because that file
// is at the 300-line cap, and because a leaf module keeps the mutation hooks
// from importing the page-data hook just to reach one pure function. ONE
// definition, imported by the load AND by every mutation refresh (duplicate,
// restore, delete, decommission, assign-group), so the two cannot drift.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import { MachinesQuery } from "../../models/models";

export const fleetFetchQuery = (q: MachinesQuery): MachinesQuery => ({
  search: q.search,
  groupBy: q.groupBy,
});

export default fleetFetchQuery;
